export default __webpack_public_path__ + "static/media/GlyGen-SandBox-img.1e890b86.svg";